import i18next from 'i18next';

export default function NotFound() {
  return (<div style={{ width: '75%' }}>
    <p style={{ color: 'rgb(189, 148, 94)', fontSize: '48px' }}>{i18next.t('error.404')}</p>
    <p style={{ color: 'black', fontSize: '24px', fontWeight: 'bold' }}>{i18next.t('error.404Message')}</p>
    <p style={{ color: 'black' }}>{i18next.t('error.404Description')}</p>
  </div>);
}